import React from "react";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { SR_CHAT_ACCENT } from "../sr-constants";

type Props = {
    showChats: boolean;
    sending: boolean;
    onToggleChats: () => void;
    onNewChat: () => void;
};

export const SrChatHeader: React.FC<Props> = ({
    showChats,
    sending,
    onToggleChats,
    onNewChat,
}) => (
    <div className="flex items-center justify-between gap-3 border-b border-slate-200/70 bg-white/80 px-4 py-2.5 backdrop-blur-sm">
        <p className="sr-chat-status truncate text-slate-500">
            {showChats ? "Chats" : "Online · text or voice"}
        </p>
        <div className="flex shrink-0 items-center">
            <Tooltip title="Chat history">
                <span>
                    <IconButton
                        size="small"
                        onClick={onToggleChats}
                        aria-label="chat history"
                        sx={{ color: showChats ? SR_CHAT_ACCENT : "#64748B" }}
                    >
                        <HistoryOutlinedIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="New chat">
                <span>
                    <IconButton
                        size="small"
                        onClick={onNewChat}
                        disabled={sending}
                        aria-label="new chat"
                        sx={{ color: "#64748B" }}
                    >
                        <AddCommentOutlinedIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </div>
    </div>
);
